import { Button } from "@design-system/Button/Button";
import { useDataGridContext } from "../DataGridContext";
import { StateMessage } from "./StateMessage";
import styles from "./states.module.scss";

/** Renders only on `status.state === "error"`: "Failed to load {noun}" and Retry. */
export const DataGridError = () => {
    const { status, noun } = useDataGridContext();
    if (status.state !== "error") {
        return null;
    }
    return (
        <StateMessage role="alert">
            <p className={styles.title}>Failed to load {noun}</p>
            {status.onRetry ? (
                <Button variant="secondary" size="sm" onClick={status.onRetry}>
                    Retry
                </Button>
            ) : null}
        </StateMessage>
    );
};
